<template>
    <!-- 数据表格 -->
    <el-card class="table-card" shadow="never">
        <el-button type="primary" @click="addTag">新增</el-button>
        <div class="table-wrapper">
            <el-table :data="cardTagStore.tags" v-loading="loading" style="width: 100%">
                <el-table-column prop="name" label="Name" width="160">
                    <template #default="scope">
                        <el-link underline="always" type="primary" @click="editTag(scope.row)">{{ scope.row.name
                            }}</el-link>
                    </template>
                </el-table-column>
                <el-table-column prop="sort" label="Sort" width="80" />
            </el-table>
        </div>

        <el-dialog v-model="newTagParams.showDialog" :title="newTagParams.id ? '修改标签' : '新增标签'" width="600px">
            <el-form :model="newTagParams" label-width="100px">
                <el-form-item label="名称" prop="name" required>
                    <el-input v-model="newTagParams.name" maxlength="20" show-word-limit
                        word-limit-position="outside" />
                </el-form-item>
                <el-form-item label="排序值" prop="sort" required>
                    <el-input-number v-model="newTagParams.sort" />
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="newTagParams.showDialog = false">取消</el-button>
                <el-button v-loading="newTagParams.loading" type="primary" @click="submit">确定</el-button>
            </template>
        </el-dialog>
    </el-card>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { ElMessage } from "element-plus";
import { useCardTagStore } from "@/stores/card/tag";

const cardTagStore = useCardTagStore();

const loading = ref(false);

const newTagParams = reactive({
    showDialog: false,
    id: "",
    name: "",
    sort: 50,
    loading: false,
});

async function loadData() {
    loading.value = true;

    const response = await cardTagStore.getAll();
    if (!response) {
        return false;
    }

    loading.value = false;
}

function addTag() {
    newTagParams.id = "";
    newTagParams.name = "";
    newTagParams.sort = 50;
    newTagParams.showDialog = true;
}

function editTag(row) {
    newTagParams.id = row.id;
    newTagParams.name = row.name;
    newTagParams.sort = row.sort;
    newTagParams.showDialog = true;
}

async function submit() {
    let success = false;
    if (!newTagParams.id) {
        success = await submitAddTag();
    } else {
        success = await submitEditTag();
    }

    if (success) {
        newTagParams.showDialog = false;
    }
}

async function submitAddTag() {
    newTagParams.loading = true;

    const response = await cardTagStore.add({
        name: newTagParams.name,
        sort: newTagParams.sort,
    });
    newTagParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("增加标签成功");
    return true;
}

async function submitEditTag() {
    newTagParams.loading = true;

    const response = await cardTagStore.edit(newTagParams.id, {
        name: newTagParams.name,
        sort: newTagParams.sort,
    });
    newTagParams.loading = false;
    if (!response) {
        return false;
    }
    ElMessage.success("修改标签成功");
    return true;
}

onMounted(async () => {
    await loadData();
});
</script>

<style scoped>
</style>
